const state = {
    autocompleteFocus: null,
    internalId:        null,
    version:           0.0
};

const getters = {
    getAutocompleteFocus: state => state.autocompleteFocus,
    getInternalId:        state => state.internalId,
    getVersion:           state => state.version,
};

const mutations = {
    SET_AUTOCOMPLETE_FOCUS(state, payload) {
        state.autocompleteFocus = payload;
    },
    SET_INTERVAL_ID(state, payload) {
        state.internalId = payload;
    },
    SET_VERSION(state, payload) {
        state.version = payload;
    },
};

const actions = {
    setAutocompleteFocus({commit}, focus) {
        commit('SET_AUTOCOMPLETE_FOCUS', focus);
    },
    setIntervalId({commit}, intervalId) {
        commit('SET_INTERVAL_ID', intervalId);
    },
    setVersion({commit}, version) {
        commit('SET_VERSION', version);
    },
};

export default {
    state,
    actions,
    getters,
    mutations
};
